import { apiFetch } from "../utils/apiFetch";
import { API_BASE_ADMIN } from "../config/vars";

export async function fetchLicenseStatus() {
    const res = await apiFetch(`${API_BASE_ADMIN}/license/status`);
    if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.detail || "Не вдалося отримати статус ліцензії");
    }
    return res.json();
}

export async function setLicenseToken(token) {
    const res = await apiFetch(`${API_BASE_ADMIN}/license`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token }),
    });
    if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.detail || "Не вдалося зберегти ліцензію");
    }
    return res.json();
}

export async function fetchNetworkLicenseStatus(networkId) {
    const res = await apiFetch(`${API_BASE_ADMIN}/license/network/${networkId}/status`);
    if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.detail || "Не вдалося отримати статус ліцензії мережі");
    }
    return res.json();
}

export async function fetchNetworksLicenseOverview() {
    const res = await apiFetch(`${API_BASE_ADMIN}/license/admin/networks-overview`);
    if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.detail || "Не вдалося завантажити ліцензії мереж");
    }
    return res.json();
}

export async function createNetworkLicenseRenewalRequest(networkId, comment) {
    const res = await apiFetch(`${API_BASE_ADMIN}/license/network/${networkId}/renewal-request`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ comment }),
    });
    if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.detail || "Не вдалося надіслати запит");
    }
    return res.json();
}

export async function fetchLicenseRenewalRequests(status = "pending") {
    const q = status ? `?status=${encodeURIComponent(status)}` : "";
    const res = await apiFetch(`${API_BASE_ADMIN}/license/renewal-requests${q}`);
    if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.detail || "Не вдалося завантажити запити");
    }
    return res.json();
}

export async function resolveLicenseRenewalRequest(requestId, status, resolverNote = "") {
    const res = await apiFetch(`${API_BASE_ADMIN}/license/renewal-requests/${requestId}/resolve`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            status,
            resolver_note: resolverNote || null,
        }),
    });
    if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.detail || "Не вдалося обробити запит");
    }
    return res.json();
}

export async function setNetworkLicenseToken(networkId, token) {
    const res = await apiFetch(`${API_BASE_ADMIN}/license/network/${networkId}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token }),
    });
    if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.detail || "Не вдалося зберегти ліцензію мережі");
    }
    return res.json();
}

export async function clearNetworkLicense(networkId) {
    const res = await apiFetch(`${API_BASE_ADMIN}/license/network/${networkId}`, {
        method: "DELETE",
    });
    if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.detail || "Не вдалося очистити ліцензію мережі");
    }
    return res.json();
}

export async function extendNetworkLicense(networkId, expiresOverrideAtUtc) {
    const res = await apiFetch(`${API_BASE_ADMIN}/license/network/${networkId}/extend`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ expires_override_at_utc: expiresOverrideAtUtc }),
    });
    if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.detail || "Не вдалося продовжити ліцензію мережі");
    }
    return res.json();
}
